export default __webpack_public_path__ + "static/media/profileDark.6c316a51.svg";